import store from '@/store'
import tkPayment from './tkPayment'
// import qData from '@/assets/qData/qData'
const math = require('mathjs')
const tkParse = require('@moke/vue-tk').tkParse
const tkUa = require('@moke/vue-tk').tkUa
// const tkHelper = require('@moke/vue-tk').tkHelper

// 转为水印地址
function waterMarkImage (splitUrl) {
  return splitUrl
  // let url = ''
  // let index = splitUrl.toString().indexOf('https://')
  // if (index === -1) {
  //   url = tkHelper.getWaterMarkedImageUrl(splitUrl, {
  //     image: qData.markNotImage,
  //     P: 20,
  //     g: 'se'
  //   })
  // } else {
  //   url = tkHelper.getWaterMarkedImageUrl(splitUrl, {
  //     image: qData.markImage,
  //     P: 20,
  //     g: 'se'
  //   })
  // }
  // return url
}

/**
 * 保留名字
 * @date: 2020/4/7
 */
function getImageName (s) {
  return s.replace('https://s3.moke.cloud/dianpei/', '')
}

/**
* 解决浮点问题方法
* @date: 2020/5/11
*/
function floatingPoint (num1, num2, type) {
  let result = 0
  switch (type) {
    case 'add': // 加
      result = math.format(math.chain(math.bignumber(num1)).add(math.bignumber(num2)).done())
      break
    case 'subtract': // 减
      result = math.format(math.chain(math.bignumber(num1)).subtract(math.bignumber(num2)).done())
      break
    case 'multiply': // 乘
      result = math.format(math.chain(math.bignumber(num1)).multiply(math.bignumber(num2)).done())
      break
    case 'divide': // 除
      result = math.format(math.chain(math.bignumber(num1)).divide(math.bignumber(num2)).done())
      break
  }
  return Number(result)
}
/**
* 用户账号类别
* @date: 2020/4/29
*/
function userCategory () {
  if (!store.state.user) return null
  return store.state.user.accountCategory
}
/**
* 是否为终端账号用于判断价格显示
* @date: 2020/4/29
*/
function isTerminalAccount () {
  return !!(userCategory() && userCategory() === 'terminalAccount')
}
/**
 * 商品价格处理
 * @date: 2020/4/2
 */
function priceProcessing (arr, judgeTimeRule) {
  arr.forEach(s => {
    if (s.typeActivity === 'panicBuying' && judgeTimeRule) { // 限时抢购价格处理
      if (isTerminalAccount()) {
        s.price = s.activityTerminalPrice || s.terminalPrice
        s.oldPrice = s.terminalPrice
      } else {
        s.price = s.activityCountyPrice || s.countyPrice
        s.oldPrice = s.countyPrice
      }
    } else if (s.typeActivity === 'promotions') {
      if (isTerminalAccount()) {
        s.price = s.activityTerminalPrice || s.terminalPrice
        s.oldPrice = s.terminalPrice
      } else {
        s.price = s.activityCountyPrice || s.countyPrice
        s.oldPrice = s.countyPrice
      }
    } else if (!s.typeActivity || (s.typeActivity === 'panicBuying' && !judgeTimeRule)) {
      if (isTerminalAccount()) {
        s.price = s.terminalPrice
      } else {
        s.price = s.countyPrice
      }
    }
  })
  return arr
}
/**
* 更新钱包信息
* @date: 2020/4/11
*/
async function updateWallet (user, wallet, key, changeValue) {
  let obj = {}
  obj[key] = changeValue
  if (!wallet) {
    obj.user = user
    await tkParse.post('/classes/wallet', obj)
  } else {
    await tkParse.put(`/classes/wallet/${wallet.objectId}`, obj)
  }
}
/**
* 添加收支明细
* @date: 2020/4/11
*/
async function addRevenue (className, user, access, number, revenue, realTimeBalance) {
  await tkParse.post(`/classes/${className}`, {
    user: user,
    access: access,
    number: number,
    revenue: revenue,
    realTimeBalance: realTimeBalance
  })
}
/**
 * @param payMoney 支付金额
 * @param desc 支付说明
 * @param channel 支付方式
 * @returns {Promise<void>}
 */
async function payMoneyOnLine (payMoney, channel, desc, id) {
  return new Promise(async (resolve, reject) => {
    await tkPayment.create({
      channel: channel,
      title: desc,
      fee: floatingPoint(payMoney, 100, 'multiply'),
      id: id
    }, false).then((res) => {
      resolve(res)
    }).catch(e => {
      resolve('fail')
    })
  })
}
/**
 * 支付订单
 * @date: 2020/5/15
 */
async function payMoney (id, amount, payChannel) {
  try {
    if (amount > 0) { // 不为0元购买
      // 支付
      let payStatus = await payMoneyOnLine(amount, payChannel, '(威选商城)购买商品', id)
      if (payStatus === 'fail') {
        return false
      }
      // 对比支付金额和订单金额是否匹配
      if (tkUa.isPlus) {
        let contrastAmount = (JSON.parse(payStatus).message.fee / 100) * 100 / 100
        if (contrastAmount !== amount) {
          await tkParse.post('/classes/error', { orderId: id, message: '实付金额与订单金额不符' })
          return false
        }
      }
    }
    return true
  } catch (e) {
    return false
  }
}
/**
 * 统计相关数量接口调用方法
 * @date: 2020/3/31
 */
async function statisticsNum (className, obj) {
  let countData = await tkParse.get(`/classes/${className}`, {
    params: {
      count: 1,
      limit: 0,
      where: obj
    }
  })
  if (countData.data.count) { return countData.data.count } else { return 0 }
}
/**
 * 用于判断数据库有没有此数据
 * @date: 2020/3/31
 */
async function judgeId (id, path) {
  let judgeOrder = await tkParse.getList(`/classes/${path}`, {
    params: {
      where: {
        objectId: id
      }
    }
  })
  return !!judgeOrder.length
}
/**
 * 查询任务id
 * @param {String} orderId
 * @param {String} eventName
 * @returns {Promise<{jobId: *}>} 返回值
 * @private
 */
async function getJobOrder (eventName, orderId) {
  // eslint-disable-next-line no-return-await
  return await tkParse.getList('/classes/scheduleJob', {
    params: {
      limit: 1,
      where: {
        eventName: eventName,
        arg: { $regex: `${orderId}` },
        isDeleted: false
      }
    }
  })
}
export {
  getImageName,
  waterMarkImage,
  floatingPoint,
  priceProcessing,
  updateWallet,
  addRevenue,
  payMoneyOnLine,
  payMoney,
  statisticsNum,
  judgeId,
  getJobOrder
}
